module.exports = __webpack_public_path__ + "static/media/button-create-new.d88fc0f9.svg";